import { Store } from 'antd/lib/form/interface';
import { ColumnsType } from 'antd/lib/table';
import { ReportKey, ReportsFilters, ReportsSortBy } from '@models/interfaces';
import { getGenericSortableColumn } from './common';

export const getReportColumns = (
  reportKey: ReportKey,
  filters: ReportsFilters,
): ColumnsType<any> => {
  switch (reportKey) {
    case ReportKey.DatesAtAGlance:
      return [
        getGenericSortableColumn(
          'projectBundleID',
          'Project Bundle ID',
          ReportsSortBy.ProjectBundleID,
          filters,
        ),
        getGenericSortableColumn(
          'taskName',
          'Milestone',
          ReportsSortBy.TaskName,
          filters,
        ),
        { dataIndex: 'paceTaskID', title: 'PACE Task ID' },
        { dataIndex: 'paceTaskScreensDisplay', title: 'PACE Task Module(s)' },
        getGenericSortableColumn(
          'forecastedDate',
          'Forecasted Date',
          ReportsSortBy.ForecastDate,
          filters,
        ),
        { dataIndex: 'PACEForecastedDate', title: 'PACE Forecasted Date' },
        getGenericSortableColumn(
          'actualDate',
          'Actual Date',
          ReportsSortBy.ActualDate,
          filters,
        ),
        { dataIndex: 'PACEActualDate', title: 'PACE Actual Date' },
      ];
    case ReportKey.NewClosedProjects:
      return [
        getGenericSortableColumn(
          'period',
          'Period',
          ReportsSortBy.Period,
          filters,
        ),
        getGenericSortableColumn(
          'newCount',
          'New',
          ReportsSortBy.NewCount,
          filters,
        ),
        getGenericSortableColumn(
          'closedCount',
          'Closed',
          ReportsSortBy.ClosedCount,
          filters,
        ),
        { dataIndex: 'netChange', title: 'Net Change' },
      ];
    case ReportKey.ProjectDuration:
      return [
        getGenericSortableColumn(
          'projectBundleID',
          'Project Bundle ID',
          ReportsSortBy.ProjectBundleID,
          filters,
        ),
        getGenericSortableColumn(
          'projectType',
          'Project Type',
          ReportsSortBy.ProjectType,
          filters,
        ),
        { dataIndex: 'startDate', title: 'Project Assigned Date' },
        { dataIndex: 'endDate', title: 'Actual Date' },
        getGenericSortableColumn(
          'durationDays',
          'Duration Days',
          ReportsSortBy.DurationDays,
          filters,
        ),
      ];
    case ReportKey.StructuralPassFail:
      return [
        getGenericSortableColumn(
          'projectBundleID',
          'Project Bundle ID',
          ReportsSortBy.ProjectBundleID,
          filters,
        ),
        getGenericSortableColumn(
          'projectType',
          'Project Type',
          ReportsSortBy.ProjectType,
          filters,
        ),
        getGenericSortableColumn(
          'progressStatus',
          'Progress Status',
          ReportsSortBy.ProgressStatus,
          filters,
        ),
        getGenericSortableColumn(
          'structuralResult',
          'Structural Result',
          ReportsSortBy.StructuralResult,
          filters,
        ),
      ];
    case ReportKey.OverdueTasks:
    default:
      return [];
  }
};

export const getGenericReportRowKey = (record: Store): string =>
  [record.projectId, record.projectBundleID, record.paceTaskId, record.period]
    .filter(Boolean)
    .join('-');
